// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7964":"dddf03c4","9568":"dddf03c4"}[chunkId] + ".chunk.css";
};